import { render, staticRenderFns } from "./BaseMediaAccounts.vue?vue&type=template&id=40970f27&scoped=true&"
import script from "./BaseMediaAccounts.vue?vue&type=script&lang=js&"
export * from "./BaseMediaAccounts.vue?vue&type=script&lang=js&"
import style0 from "./BaseMediaAccounts.vue?vue&type=style&index=0&id=40970f27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40970f27",
  null
  
)

export default component.exports